<template>
  <bc-tree
    v-if="trashBin === bcFolderStore.trashBin && bcFolderStore.show === show"
    :items="bcFolderStore.tree"
    v-model="openedFolders"
    item-key="url"
    v-slot="slotProps"
    drop-area-id="bc-tree-0"
    :parent-bc-folder-id="0"
    :can-drop="$presenter.rootFolder.can_edit && bcFolderStore.show == 'bc' && bcFolderStore.order == 'rank'"
  >
    <folders-left-nav-item
      v-model="openedFolders"
      :toggle="slotProps.toggle"
      :open="slotProps.open"
      :item="slotProps.item"
      :active-current="bcFolderStore.leftMenuCurrent"
      :icon="null"
      :st-level="true"
      :folder-icon="slotProps.item.link ? 'link' : 'folder'"
      :origin-drop-area-id="slotProps.dropAreaId"
      folder-opened-icon="folder-opened"
      :key="slotProps.item.url"
    />
  </bc-tree>
  <span
    v-if="bcFolderStore.tree.length"
    class="block mb-0 xl:mb-4" 
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import BcTree from './BcTree.vue'

export default {
  components: { BcTree },
  props: {
    trashBin: {
      type: Boolean,
      default: false
    },
    show: {
      type: String,
      default: 'bc'
    }
  },
  computed: {
    openedFolders: {
      get() {
        return this.bcFolderStore.leftMenuOpened
      },
      set(val) {
        this.bcFolderStore.setLeftMenuOpened(val)
      }
    },
    ...mapStores(useBcFolderStore)
  },
}
</script>

<style lang="scss" scoped></style>
